import React, { Component, Fragment } from 'react';
import { withNamespaces }             from 'react-i18next';
import { connect }                    from 'react-redux';
import { toast }                      from 'react-toastify';
import PropTypes                      from 'prop-types';
import { compose }                    from 'redux';
import {
  ContentHeader,
  ExportExcel,
  Filter,
  FormElement,
  Loading,
  Switch,
  TableList,
  Toggle,
  TransactionRow
}                                     from '../../components';
import { authActions }                from '../../state/ducks/auth';
import { usersActions }               from '../../state/ducks/users';
import { companyActions }             from '../../state/ducks/company';
import {
  initTimer,
  stopTimer
}                                     from '../../util/initTimer';
import {
  SIZE_PER_PAGE,
  TOAST_CONFIG
}                                     from '../../config/constants';
import { formatDate }                 from '../../util';
import UserEdit                       from "../userEdit";
import ReactTooltip                    from "react-tooltip";

class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      dateStart: '',
      dateEnd: '',
      cuit: '',
      emailCompany: '',
      nameCompany: '',
      status: '',
      province: '',
      locationCompany: '',
      switchList: [],
      first: true,
    }
  }

  componentDidMount() {
    const { fetchStatusFilter, fetchProvince } = this.props;
    fetchStatusFilter();
    fetchProvince();
    stopTimer();
    initTimer(this.props);
    this.callApiList();
  }

  callApiList = (getExcel = false) => {
    const {
      t, showMessage, fetchTransportCompany, fetchLocations,
      users: { provinces, locations },
      company: { companyTransport: { totalElements } },
    } = this.props;
    const {
      page, dateStart, dateEnd, cuit, emailCompany, nameCompany, status, locationCompany,
      first, province
    } = this.state;

    let proCompany = province;
    if (province === '' && first === true) {
      proCompany = provinces.length > 0 ? provinces[13].id : 1;
      this.setState({
        first: false,
        province: proCompany,
      });
    }

    fetchTransportCompany({
      data: {
        pageSize: !getExcel ? SIZE_PER_PAGE : totalElements,
        page: getExcel ? 0 : page,
        export: getExcel,
        date_from: formatDate(dateStart),
        date_to: formatDate(dateEnd),
        cuit,
        email: emailCompany,
        name: nameCompany,
        status,
        province: proCompany,
        location: locationCompany,
      }, callback: (response) => {
        if (response) {
          if (!response.success) {
            toast.dismiss();
            showMessage({
              message: t('connectionError'),
              config: TOAST_CONFIG.ERROR,
            });
          }
        } else {
          toast.dismiss();
          showMessage({
            message: t('connectionError'),
            config: TOAST_CONFIG.ERROR,
          });
        }
      },
    });

    fetchLocations({
      data: {
        id: proCompany,
      }, callback: (success, data) => {
        if (!success) {
          toast.dismiss();
          showMessage({
            message: t('connectionError'),
            config: TOAST_CONFIG.ERROR,
          });
        }
      },
    });
  }

  handleInputChange = (event) => {
    stopTimer();
    initTimer(this.props);
    const { target: { value: targetValue, name } } = event;
    this.setState({
      [name]: targetValue,
    });
  };

  onChangePage = (selectPage) => {
    stopTimer();
    initTimer(this.props);
    this.setState(() => ({
      page: selectPage ? selectPage.selected : 0,
    }), () => {
      this.callApiList();
    });
  };

  onChangeDate = (date, name) => {
    stopTimer();
    initTimer(this.props);
    const dateValue = date !== null ? date : '';
    this.setState({
      [name]: dateValue,
    });
  };

  handleActiveDisable = (event, i, id_user) => {
    const item = event.target.name;
    const isChecked = event.target.checked;
    const { switchList } = this.state;
    switchList[i] = isChecked;
    this.setState({ switchList });
    const { t, showMessage, updateStateCompany } = this.props;
    const data = {
      id_user: id_user,
      new_status: !isChecked ? 0 : 1,
    };
    const status = isChecked ? 'activó' : 'desactivó';
    updateStateCompany({
      data,
      callback: (response) => {
        if (response.success) {
          toast.dismiss();
          showMessage({
            message: t('activeDisableUSerSuccess', { status }),
            config: status === 'activó' ? TOAST_CONFIG.SUCCESS : TOAST_CONFIG.INFO,
          });
        } else {
          toast.dismiss();
          showMessage({
            message: t('saveUserDataError'),
            config: TOAST_CONFIG.ERROR,
          });
        }
      },
    });
  }

  detailUser = async (id) => {
    stopTimer();
    initTimer(this.props);
    await this.setState(() => ({
      loading: true,
    }));
    const { detailUser, dataFiscal } = this.props;
    const data = { identification: id };
    await detailUser({
      data,
      callback: async (response) => {
        const { success, data: userDetail } = response;
      },
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.onChangePage();
    this.callApiList();
  };

  render() {
    const {
      t, company: { loading, companyTransport: { list, totalElements } },
      users: { statusFilter, provinces, locations },
    } = this.props;
    const {
      page, dateStart, dateEnd, cuit, emailCompany, nameCompany, status, province,
      locationCompany, switchList,
    } = this.state;
    return (
      <div>
        {loading && <Loading />}
        <Toggle>
          {({ toggled, onToggle, toggleProps }) => {
            return (
              <Fragment>
                {toggled && (
                  <UserEdit
                    identification={toggleProps.identification}
                    handleReturn={() => {
                      this.callApiList();
                      onToggle();
                    }}
                  />
                )}
                {!toggled && (
                  <Fragment>
                    <div className='wow animated slideInDown'>
                      <div className='wow animated slideInDown'>
                        <Filter title={t('companyList')} onSubmit={e => this.onSubmit(e)}>
                          <FormElement
                            name='dateStart'
                            onChange={ev => this.onChangeDate(ev, 'dateStart')}
                            label={t('createdDateFrom')}
                            value={dateStart}
                            typeElement='datepicker'
                            maxDate={dateEnd || new Date()}
                          />
                          <FormElement
                            name='dateEnd'
                            onChange={ev => this.onChangeDate(ev, 'dateEnd')}
                            value={dateEnd}
                            label={t('createdDateUntil')}
                            typeElement='datepicker'
                            maxDate={new Date()}
                            minDate={dateStart}
                          />
                          <FormElement
                            name='cuit'
                            onChange={this.handleInputChange}
                            value={cuit}
                            label={'CUIT'}
                            typeElement='input'
                          />
                          <FormElement
                            name='emailCompany'
                            onChange={this.handleInputChange}
                            value={emailCompany}
                            label={t('email')}
                            typeElement='input'
                          />
                          <FormElement
                            name='nameCompany'
                            onChange={this.handleInputChange}
                            value={nameCompany}
                            label={t('nameCompany')}
                            typeElement='input'
                          />
                          <FormElement
                            name='status'
                            onChange={this.handleInputChange}
                            value={status}
                            label={t('state')}
                            optionsSelect={statusFilter}
                            placeholder={t('selectState')}
                            typeElement="select"
                            controlClasses="select"
                          />
                          <FormElement
                            name='province'
                            onChange={this.handleInputChange}
                            value={province}
                            label={t('selectProvince')}
                            optionsSelect={provinces}
                            placeholder={t('selectState')}
                            typeElement="select"
                            controlClasses="select"
                            disabled
                          />
                          <FormElement
                            name='locationCompany'
                            onChange={this.handleInputChange}
                            value={locationCompany}
                            label={t('location')}
                            optionsSelect={locations}
                            placeholder={t('selectLocation')}
                            typeElement="select"
                            controlClasses="select"
                          />
                        </Filter>
                        <ContentHeader
                          headingRightText={t('companyTotal')}
                          headingRightSubText={`${totalElements}`}
                        >
                          <ExportExcel onclick={() => { this.callApiList(true) }} />
                          <TableList
                            tableClasses="floating-table"
                            totalElements={parseFloat(totalElements)}
                            onChangePage={this.onChangePage}
                            forcePage={page}
                            head={(
                              <tr>
                                <th>{`${t('date')} / ${t('hour')}`}</th>
                                <th>{t('CUIT')}</th>
                                <th>{t('nameCompany')}</th>
                                <th>{t('email')}</th>
                                <th>{t('CVU')}</th>
                                <th>{t('location')}</th>
                                <th>{t('status')}</th>
                                <th colSpan="2">{t('actions')}</th>
                              </tr>)}
                            colNumber={8}
                            lenghtData={totalElements !== undefined ? totalElements : 0}
                          >
                            {list && (list.map((transport, i) => (
                              <TransactionRow
                                key={i}
                                icon={'far fa-edit icons-actions'}
                                helper={t('edit')}
                                openDetail={async () => {
                                  stopTimer();
                                  initTimer(this.props);
                                  const { detailUser, clearUserDetail } = this.props;
                                  const data = { identification: transport.identification };
                                  await clearUserDetail();
                                  await detailUser({
                                    data,
                                    callback: async (response) => {
                                      const { success, data: userDetail } = response;
                                      if (success) {
                                        onToggle(transport);
                                      }
                                    },
                                  });
                                }}
                              >
                                <td>{transport.date}</td>
                                <td>{transport.cuit}</td>
                                <td>{transport.name}</td>
                                <td>{transport.email}</td>
                                <td>{transport.cvu === undefined ? `${t('notAvailable')}` : transport.cvu}</td>
                                <td>{transport.location}</td>
                                <td>{switchList[i] !== undefined ? (switchList[i] === true ? t('active') : t('inactive')) : (transport.status === '1' ? t('active') : t('inactive'))}</td>
                                <td>
                                  <div className='columns is-centered'>
                                    <div className='column'
                                      aria-hidden="true"
                                      data-for={`switch-orange-${i}`}
                                      data-tip="Test"
                                      >
                                      <Switch
                                        name={`switch-${i}`}
                                        id={`switch-orange-${i}`}
                                        value={switchList[i] !== undefined ? switchList[i] : (transport.status === '1')}
                                        onChange={(event) => {this.handleActiveDisable(event, i, transport.id_user)}}
                                        checked={switchList[i] !== undefined ? switchList[i] : (transport.status === '1')}
                                        htmlFor={`switch-orange-${i}`}
                                      />
                                      <ReactTooltip
                                        id={`switch-orange-${i}`}
                                        effect="solid"
                                        className='text-toltip'
                                      >
                                        {switchList[i] !== undefined ? (switchList[i] === true ? t('deactivate') : t('activate')) : (transport.status === '1' ? t('deactivate') : t('activate'))}
                                      </ReactTooltip>
                                    </div>
                                  </div>
                                </td>
                              </TransactionRow>
                            )))}
                          </TableList>
                        </ContentHeader>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Fragment>
            );
          }}
        </Toggle>
      </div>
    );
  }
}

CompanyList.propTypes = {
  t: PropTypes.func.isRequired,
  showMessage: PropTypes.func,
  fetchStatusFilter: PropTypes.func,
  fetchProvince: PropTypes.func,
  fetchTransportCompany: PropTypes.func.isRequired,
};

CompanyList.defaultProps = {
  showMessage: () => {},
  fetchStatusFilter: () => {},
  fetchProvince: () => {},
};

const mapStateToProps = ({ auth, company, users }) => (
  { auth, company, users }
);

export default compose(connect(mapStateToProps, {
    ...authActions,
    ...companyActions,
    ...usersActions,
  }),
  withNamespaces())(CompanyList);
